function repositionFooter() {
  // $("#signature").remove();
  $("#footer .contact-box .facebook a").text("");
  $("#footer .contact-box .instagram a").text("");

  $("#footer .contact-box .facebook").closest("li").addClass("social-item");
  $("#footer .contact-box .instagram").closest("li").addClass("social-item");

  $(".footer-icons #pm_script_dynamic-right").closest("div").hide();

  $("#footer .footer-bottom").append(
    '<img class="img-responsive footer-bg" src="/user/documents/upload/images/footer-bg.png">'
  );

  $("#footer .custom-footer__newsletter .form-control").attr(
    "placeholder",
    "Emailová adresa"
  );
  $("#footer .custom-footer__newsletter .btn").text("Pridaj sa!");
  $("#footer .custom-footer__newsletter h4 span").text("Chrústiček Newsletter");
}
